import script from "./MultiFormItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultiFormItem.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__